import MemberRepo from '../../../Repo/MemberRepo'
import {NavigatorForMemberPage} from '../../../Navigator/NavigatorForMemberPage'
import {useAsync} from 'react-use'
import {useParams} from 'react-router-dom'
import {MBMemberError} from '../../../Common/MBMemberError'
import React from 'react'
import {Logout} from '../../../../Common/Components/Logout'
import {CommonResponseStatus} from '../../../../Network/CommonResponse'
import {membersMsalInstance} from '../../../Auth/members-msa'
import {useMBMemberError} from '../../Hooks/UseMBMemberError'
import {useMsal} from '@azure/msal-react'

type Props = {
  navigator: NavigatorForMemberPage
  memberRepo: MemberRepo
}

export function MembersEditMailRedirectPage(props: Props): JSX.Element {
  const throwMBMemberError = useMBMemberError()
  const {mailUpdateId} = useParams<{ mailUpdateId: string }>()
  const {inProgress} = useMsal()

  const result = useAsync(async () => {
    return await props.memberRepo.putMailUpdateComplete(mailUpdateId)
  })

  if (result.loading) {
    return <></>
  }

  if (result.error) {
    throw new MBMemberError(result.error.message)
  }

  if (!result.value) {
    throw new MBMemberError('UnknownError')
  }

  switch (result.value.status) {
    case CommonResponseStatus.Ok:
      return <Logout
        msalInstance={membersMsalInstance}
        postLogoutRedirectUri="/account/information/mail/update_complete"
        throwMBError={throwMBMemberError}
        navigate={(): void => {
          props.navigator.goToEditMailUpdatedPage()
        }}
        inProgress={inProgress}
      />
    case CommonResponseStatus.NotFound:
      throw new MBMemberError('NotFound')
    case CommonResponseStatus.Forbidden:
      throw new MBMemberError('InvalidOneTimeUrl')
    case CommonResponseStatus.Conflict:
      throw new MBMemberError('InvalidOneTimeUrl')
    case CommonResponseStatus.NoAuthority:
      throw new MBMemberError('SystemError')
    case CommonResponseStatus.InternalServerError:
      throw new MBMemberError('ServerError')
    default:
      throw new MBMemberError('UnknownError')
  }
}
